import * as React from 'react';
import { IgcLinearProgressComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A linear progress indicator used to express unspecified wait time or display
 * the length of a process.
 * @slot  - The text area container.
 * @csspart track - The igc-linear-progress track area.
 * @csspart fill - The igc-linear-progress indicator area.
 * @csspart striped - The igc-linear-progress striped indicator.
 * @csspart label - The igc-linear-progress label.
 * @csspart value - The igc-linear-progress label value.
 * @csspart indeterminate - The igc-linear-progress indeterminate state.
 * @csspart primary - The igc-linear-progress indicator primary state.
 * @csspart danger - The igc-linear-progress indicator error state.
 * @csspart warning - The igc-linear-progress indicator warning state.
 * @csspart info - The igc-linear-progress indicator info state.
 * @csspart success - The igc-linear-progress indicator success state.
 * @class
 */
export const IgrLinearProgress = /* @__PURE__ */ createComponent({
  tagName: 'igc-linear-progress',
  displayName: 'IgrLinearProgress',
  elementClass: Component,
  react: React,
});

export type IgrLinearProgress = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrLinearProgressModule = Component;
